/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectDetailDto } from '../../models/backend-project-detail-dto';

export interface GetProjectProjectsProjectIdGet$Params {
  project_id: number;
}

export function getProjectProjectsProjectIdGet(
  http: HttpClient,
  rootUrl: string,
  params: GetProjectProjectsProjectIdGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectDetailDto>> {
  const rb = new RequestBuilder(rootUrl, getProjectProjectsProjectIdGet.PATH, 'get');
  if (params) {
    rb.path('project_id', params.project_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectDetailDto>;
    }),
  );
}

getProjectProjectsProjectIdGet.PATH = '/projects/{project_id}';
